import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Img } from "@sunwing/shared-components/dist/Image/index";
import { Icon } from "../../Icon";
import styles from "./Profile.module.scss";

const defaultClassNames = {
	profile: styles.profile,
	profileActive: styles["profile--active"],
	profilePicture: styles.profile__picture,
	profilePictureBackground: styles.profile__pictureBackground,
	profileImgWrapper: styles.profile__imgWrapper,
	profileInfo: styles.profile__info,
	btnIcon: styles.btnIcon,
	btnIconActive: styles.btnIcon,
};

const Profile = ({
	name,
	role,
	image,
	isActive,
	setKey,
	activeMember,
	id,
	classNames: providedClassNames,
	theme,
	profileBackgroundColor,
}) => {
	const handleToggle = () => {
		if (activeMember === id) setKey(null);
		else setKey(id);
	};

	const classNames = {
		...defaultClassNames,
		...providedClassNames,
		profilePictureBackground:
			providedClassNames.profilePictureBackground || defaultClassNames.profilePictureBackground,
	};

	return (
		<div
			role="button"
			tabIndex={0}
			className={cx(
				classNames.profile,
				{
					[classNames.profileActive]: isActive,
				},
				styles[theme]
			)}
			onClick={handleToggle}
			onKeyDown={handleToggle}
			data-testid="infoPanel-profile-view">
			<div
				className={cx(classNames.profilePicture, classNames.profilePictureBackground)}
				style={{ background: `${profileBackgroundColor}` }}>
				<Img
					className={image.className}
					wrapperClassName={classNames.profileImgWrapper}
					src={image.src}
					source={image.source}
					alt={image.alt ?? `${name}: ${role}`}
					title={image.title}
					autoResponsive={image.autoResponsive}
					renderImage={image.renderImage}
				/>
				{isActive ? (
					<Icon
						name="minus--n"
						className={`swg-text-lg ${classNames.btnIcon} ${classNames.btnIconActive}`}
					/>
				) : (
					<Icon name="plus--n" className={`swg-text-lg ${classNames.btnIcon}`} />
				)}
			</div>
			<div className={classNames.profileInfo}>
				<div>
					<strong>{name}</strong>
				</div>
				{role}
			</div>
		</div>
	);
};

Profile.propTypes = {
	name: PropTypes.string.isRequired,
	role: PropTypes.string.isRequired,
	isActive: PropTypes.bool,
	image: PropTypes.shape({
		className: PropTypes.string,
		wrapperClassName: PropTypes.string,
		src: PropTypes.string,
		source: PropTypes.shape({
			src: PropTypes.string,
			srcSet: PropTypes.string,
			sizes: PropTypes.string,
		}),
		alt: PropTypes.string,
		title: PropTypes.string,
		autoResponsive: PropTypes.bool,
		renderImage: PropTypes.func,
	}),
	setKey: PropTypes.func.isRequired,
	activeMember: PropTypes.any.isRequired,
	id: PropTypes.string.isRequired,
	classNames: PropTypes.shape({
		profile: PropTypes.string,
		profileActive: PropTypes.string,
		profilePicture: PropTypes.string,
		profilePictureBackground: PropTypes.string,
		profileImgWrapper: PropTypes.string,
		profileInfo: PropTypes.string,
		btnIcon: PropTypes.string,
		btnIconActive: PropTypes.string,
	}),
	theme: PropTypes.oneOf(["primary", "wedding"]),
	profileBackgroundColor: PropTypes.string,
};
Profile.defaultProps = {
	isActive: false,
	image: undefined,
	classNames: {},
	theme: "primary",
	profileBackgroundColor: undefined,
};

export default Profile;
export { Profile };
